
$(document).on 'ready turbolinks:load', ->
  cleanupIframeChecker = null
  if $('form#edit_job').length > 0
    leaveUrl = null
    jobNoticeAlert = new bootstrap.Modal(document.getElementById('jobNoticeAlert'))
    iframe = document.querySelector('iframe')

    $('#edit_job').on 'ajax:error', ->
      $('#message_block').html(
        '<div class="alert alert-danger fade alert-dismissible show"><ul class="ul-disc ps-3 mb-0"><li>Internal server error</li></ul></div>'
      )

    $("#edit_job").on 'ajax:complete', (event)->
      xhr = event.detail[0]
      if ((xhr.getResponseHeader('Content-Type') || '').substring(0, 9) == 'text/html')
        referrer = xhr.responseURL
        snapshot = Turbolinks.Snapshot.wrap(xhr.response)
        Turbolinks.controller.cache.put(referrer, snapshot)
        Turbolinks.visit(referrer, { action: 'restore' })
        window.dispatchEvent(new Event('load'))
        document.dispatchEvent(new Event('DOMContentLoaded'))
        Turbolinks.dispatch('turbolinks:load')

    $(".other-text-field-tag").each ->
      otherTextElement = $(this)
      otherTextElement.closest('.df-element-main-content-wrapper').find('input[type=radio],input[type=checkbox],select').each ->
        $(this).change ->
          if (if $(this).prop('type') == 'checkbox' then $(this).parent().parent().find('input[value=_other_]').is(':checked') else $(this).val() == '_other_')
            otherTextElement.show()
            otherTextElement.focus()
          else
            otherTextElement.hide()
            otherTextElement.val('')

    setNoticeModalContent = (title, body, leaveCallback) ->
      $('#jobNoticeAlertTitle').text(title)
      $('#jobNoticeAlertBody').text(body)
      footerHtml = """
        <button type="button" class="btn btn-outline-primary m-0 me-1" data-bs-dismiss="modal" aria-label="Close">
          #{window.I18nCancelButton}
        </button>
        <a href="#{leaveUrl}" class="btn btn-primary" id="confirmLeaveBtn">
          #{window.I18nConfirmButton}
        </a>
      """
      $('#jobNoticeAlertFooter').html(footerHtml)
      $('#confirmLeaveBtn').on 'click', ->
        if leaveUrl
          window.location.href = leaveUrl
          jobNoticeAlert.hide()

    $('#edit_job a:not([target="_blank"])').on 'click', (e) ->
      link = $(this).attr('href')
      if link
        try
          clickedUrl = new URL(link, window.location.origin)
          currentDomain = window.location.hostname
          if clickedUrl.hostname != currentDomain
            e.preventDefault()
            leaveUrl = link
            setNoticeModalContent(window.NoticeAlertTitleText, window.NoticeAlertBodyText)
            jobNoticeAlert.show()
        catch error
          console.error 'Invalid URL:', link

    fetchBackgroundImage = ->
      page_background = document.getElementById('page_background')
      jobPromoDiv = document.getElementById('job-background-div')
      default_img_url = jobPromoDiv.getAttribute('data-default-url')


      if page_background
        image_url = page_background.getAttribute('data-background-id')
        if image_url
          if jobPromoDiv
            jobPromoDiv.style.backgroundPosition = 'top center'
            jobPromoDiv.style.backgroundImage = "linear-gradient(0deg, rgba(var(--dashboard-main-background-rgb), 1) 0%, rgba(var(--dashboard-main-background-rgb), 1) 15%, rgba(var(--dashboard-main-background-rgb), 0) 40%), url('"+image_url+"')"
            jobPromoDiv.style.height = '95vh'
            jobPromoDiv.style.position = 'fixed'
            jobPromoDiv.classList.add 'has-page-background'
        else
          jobPromoDiv.classList.remove 'has-page-background'
          if default_img_url
            jobPromoDiv.style.backgroundImage = "linear-gradient(0deg, rgba(var(--dashboard-main-background-rgb), 1) 0%, rgba(var(--dashboard-main-background-rgb), 1) 15%, rgba(var(--dashboard-main-background-rgb), 0) 40%), url('"+default_img_url+"')"
          else
            jobPromoDiv.style.backgroundImage = ''

    fetchBackgroundImage()
    if (iframe)
      cleanupIframeChecker = iframeAdBlockerChecker(iframe)


  if $('#workplace_jobs_edit').length > 0
    { readEml } = require('eml-parse-js')
    { html: beautifyHtml } = require('js-beautify')

    isValidS3Url = (url) ->
      try
        uri = new URL(url)
        uri.protocol == 'https:' and uri.hostname == 's3.eu-west-1.amazonaws.com'
      catch error
        false

    document.querySelectorAll('[id^="filePreviewModal-"]').forEach (modalEl) ->
      modalId = modalEl.id
      fileUrl = modalEl.getAttribute('data-file-url')
      contentEl = document.querySelector("##{modalId}-content")

      return unless fileUrl and contentEl and isValidS3Url(fileUrl)

      contentEl.innerHTML = "<center>Loading...</center>"

      fetch(fileUrl)
        .then (res) -> res.text()
        .then (rawEml) ->
          readEml rawEml, (err, parsed) ->
            if err
              contentEl.textContent = 'Failed to parse .eml file'
              return

            headers = parsed?.headers or {}
            bodyText = parsed?.text or 'n/a'
            bodyHtml = parsed?.html or 'n/a'
            contentType = parsed?.textheaders?['Content-Type'] or 'n/a'

            elementId = modalId.replace('filePreviewModal-', '')
            tabsHtml = """
                <div class="navigation pt-3 position-sticky top-0 bg-w">
                  <ul class="nav nav-tabs mb-3" id="emlTabs-#{elementId}" role="tablist">
                    <li class="nav-item" role="presentation">
                      <a class="nav-link active" id="email-tab" data-bs-toggle="tab" href="#email-#{elementId}" role="tab" aria-controls="email-#{elementId}" aria-selected="true">E-mail</a>
                    </li>
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="metadata-tab" data-bs-toggle="tab" href="#metadata-#{elementId}" role="tab" aria-controls="metadata-#{elementId}" aria-selected="false">Metadata & HTML</a>
                    </li>
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="raw-tab" data-bs-toggle="tab" href="#raw-#{elementId}" role="tab" aria-controls="raw-#{elementId}" aria-selected="false">RAW file</a>
                    </li>
                  </ul>
                </div>
                <div class="tab-content" id="emlTabsContent-#{elementId}">
                  <div class="tab-pane fade show active" id="email-#{elementId}" role="tabpanel" aria-labelledby="raw-tab">
                    <div id='email-body'></div>
                  </div>
                  <div class="tab-pane fade" id="metadata-#{elementId}" role="tabpanel" aria-labelledby="metadata-tab">
                    <table class="table table-bordered table-striped mb-0">
                      <tbody>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">From</th><td class="p-2 has-border">#{parsed?.from?.name ? ''} <span class="text-muted">&lt;</span>#{parsed?.from?.email ? 'n/a'}<span class="text-muted">&gt;</span></td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">To</th><td class="p-2 has-border">#{parsed?.to?.name ? ''} <span class="text-muted">&lt;</span>#{parsed?.to?.email ? 'n/a'}<span class="text-muted">&gt;</span></td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">cc</th><td class="p-2 has-border">#{parsed?.cc or '-'}</td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">Date</th><td class="p-2 has-border">#{parsed?.date}</td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">Subject</th><td class="p-2 has-border">#{parsed?.subject}</td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">Content Type</th><td class="p-2 has-border">#{contentType}</td></tr>
                        <tr><th scope="row" width="150" class="text-end txt4 p-2 has-border">Plain Text Body</th><td class="p-2 has-border">#{bodyText?.replace(/\n/g, "<br/>")}</td></tr>
                        <tr><th scope="row" width="150" class="text-end txt4 px-1 py-2">HTML Body</th><td class="p-0" id="html-#{elementId}"></td></tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="tab-pane fade" id="raw-#{elementId}" role="tabpanel" aria-labelledby="raw-tab">
                    <pre class='mb-0'><code class="language-html">#{rawEml.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</code></pre>
                  </div>
                </div>
              """

            contentEl.innerHTML = tabsHtml

            emailBodyContainer = document.querySelector("#email-#{elementId} #email-body")
            if emailBodyContainer?
              if bodyHtml != 'n/a'
                bodyHtml = bodyHtml.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, (match, cssContent) ->
                  "<style>#email-body { #{cssContent} }</style>"
                )
                emailBodyContainer.innerHTML = bodyHtml
              else if bodyText != 'n/a'
                emailBodyContainer.innerHTML = "#{bodyText.replace(/\n/g, "<br/>")}"
              else
                emailBodyContainer.innerHTML = "<div class='p-2 text-muted'>n/a</div>"

            htmlCell = document.getElementById("html-#{elementId}")
            if htmlCell?
              highlighted = document.createElement('pre')
              highlighted.className = 'mb-0'
              code = document.createElement('code')
              code.className = 'language-html'
              code.textContent = beautifyHtml(bodyHtml)
              highlighted.appendChild(code)
              htmlCell.appendChild(highlighted)

            rawCodeEl = document.querySelector("#raw-#{elementId} code")
            if rawCodeEl?
              hljs.highlightElement(rawCodeEl)

            if window.hljs?
              hljs.highlightElement(code)

        .catch (err) ->
          console.error(err)
          contentEl.textContent = 'Error loading file'

      $(document).on 'click', '.pin-modal', (e) ->
        $(this).toggleClass('btn-outline-primary');
        $(this).toggleClass('btn-primary');
        $(this).find('.fa-solid').toggleClass('fa-thumbtack-slash');
        $(this).find('.fa-solid').toggleClass('fa-thumbtack');
        modal = $(this).closest('.modal')
        backdrop = $('.modal-backdrop')

        if modal.hasClass('pinned')
          modal.removeClass('pinned')
          $('body').removeClass('modal-open')
          #modal.modal('hide')
          $('body').removeClass('pinned-modal-open')
        else
          modal.addClass('pinned').addClass('show').css('display', 'block')
          backdrop.remove()
          $('body').removeClass('modal-open')
          $('body').addClass('pinned-modal-open')

      $(document).on 'click', '.modal.pinned .btn-close', (e) ->
        modal = $(this)
        modal.removeClass('pinned')
        modal.css('display', '')
        modal.find('.fa-solid').removeClass('fa-thumbtack-slash').addClass('fa-thumbtack')
        modal.find('.pin-modal').addClass('btn-outline-primary').removeClass('btn-primary')
        $('body').removeClass('pinned-modal-open')

    if $('body').hasClass('rework-job-enabled')
      commentSection = document.getElementById "rework-job-comments"
      reviewCommentData = commentSection.dataset.reviewData
      commentText = if commentSection then commentSection.textContent.trim().toLowerCase() else null
      formLabels = document.querySelectorAll ".col-form-label"
      hiddenCards = 0

      if commentSection and formLabels
        reviewCommentData = JSON.parse(commentSection.dataset.reviewData || "{}")

        if Object.keys(reviewCommentData).length > 0 || commentText?.includes labelText

          if Object.keys(reviewCommentData).length
            for label in formLabels
              fullFor = label.getAttribute("for")?.trim()
              continue unless fullFor

              # Extract the slug from the for attribute (e.g. 'unnamed_image')
              slugMatch = fullFor.match(/df_create_(.+)$/)
              continue unless slugMatch and slugMatch[1]

              slug = slugMatch[1]
              continue unless reviewCommentData[slug]

              label.classList.add "rework-required"
              card = label.closest(".card")
              card?.classList.add "rework-required"



              # Add alert-danger block with comment content
              messages = reviewCommentData[slug]

              label.classList.add "rework-required"
              card = label.closest(".card")
              card?.classList.add "rework-required"

              htmlEscape = (str) ->
                String(str)
                  .replace(/&/g, '&amp;')
                  .replace(/</g, '&lt;')
                  .replace(/>/g, '&gt;')
                  .replace(/"/g, '&quot;')
                  .replace(/'/g, '&#39;')

              buildCard = (innerHtml) ->
                $("<div>")
                  .addClass("card bg-danger-subtle rework-job-comments-card use-default-bs border-2 p-3 mt-2")
                  .html(innerHtml)

              toListHtml = (val) ->
                arr = if Array.isArray(val) then val else String(val or "").split("\n").map((s) -> s.trim()).filter((s) -> s.length > 0)
                return "" if arr.length == 0
                "<ul class='mb-0 ps-3'>" + arr.map((c) -> "<li>#{htmlEscape(c)}</li>").join("") + "</ul>"


              if messages?.general?
                generalHtml = toListHtml(messages.general)
                if generalHtml?.length
                  $(label.parentNode).append(buildCard(generalHtml))

              if messages?.sub? and typeof messages.sub is "object"
                $card = $(card or document)
                for identifier, subVal of messages.sub
                  $ph = $card.find("[data-placeholder-for-media-id='#{identifier}']")
                  if $ph.length == 0
                    $ph = $card.find("[data-placeholder-for-media-name='#{identifier}']")

                  returnHtml = toListHtml(subVal)

                  if $ph.length and returnHtml?.length
                    $ph.empty().append(buildCard(returnHtml))
                    $ph.addClass("rework-required")
                  else if returnHtml?.length
                    safeId = htmlEscape(identifier)
                    fallback = buildCard("<p class='mb-1 fw-bold'>Item: #{safeId}</p>" + returnHtml)
                    $(label.parentNode).append(fallback)




          else if commentText && commentText?.includes labelText
            for label in formLabels
              labelText = label.textContent.trim().toLowerCase()
              if commentText?.includes labelText
                label.classList.add "rework-required"
                card = label.closest ".card"
                card?.classList.add "rework-required"

          # Hide unrelated cards
          $(".card.my-4").each (i, card) ->
            cardEl = $(card)
            unless cardEl.hasClass("rework-required")
              cardEl.addClass("d-none")
              hiddenCards += 1

          if $(".toggle-rework-element").length
            showAll = false
            $(".toggle-rework-element").on "click", ->
              showAll = !showAll
              if showAll
                $(".card.my-4").removeClass("d-none")
                $(".toggle-rework-element").find(".form-check-input").removeClass("checked").removeAttr("checked")
                $(".rework-job-enabled").addClass("with-element-highlighter")
                hiddenCards = null
              else
                $(".card.my-4").each (i, card) ->
                  cardEl = $(card)
                  unless cardEl.hasClass("rework-required")
                    cardEl.addClass("d-none")
                    hiddenCards = +1
                $(".rework-job-enabled").removeClass("with-element-highlighter")
                $(".toggle-rework-element").find(".form-check-input").addClass("checked").attr("checked", "checked")
        else if $(".toggle-rework-element-wrapper").length
          $("#toggle-rework-element-wrapper").addClass("d-none")
  preventPasteInTypingFields = ->
    sel = """
        .o-typing-field input,
        .o-typing-field textarea,
        .o-typing-field .not-editor,
        .o-typing-field .html_editor,
        .o-typing-field [contenteditable="true"]
    """

    showInvalid = ($el) ->
      $wrp = $el.closest('.o-typing-field')
      $ifb = $wrp.find('.invalid-feedback').first()
      $el.addClass('is-invalid')
      $ifb.text($ifb.data('invalid-message') or "Pasting isn't allowed").addClass('d-block') if $ifb.length

    clearInvalid = ($el) ->
      $wrp = $el.closest('.o-typing-field')
      $ifb = $wrp.find('.invalid-feedback').first()
      $el.removeClass('is-invalid')
      $ifb.removeClass('d-block').text('') if $ifb.length

    $(document)
      .off 'paste.oTypingField input.oTypingField'
      .on 'paste.oTypingField', sel, (e) ->
        e.preventDefault()
        showInvalid($(this))

      .on 'input.oTypingField', '.o-typing-field input.is-invalid, .o-typing-field textarea.is-invalid', ->
        clearInvalid($(this))

  preventPasteInTypingFields()



$(document).on 'turbolinks:before-cache', ->
    if typeof cleanupIframeChecker is 'function'
      cleanupIframeChecker()
      cleanupIframeChecker = null


$(document).on 'ready turbolinks:load', ->
  cleanupIframeChecker = null
  if $('form#edit_job').length > 0
    leaveUrl = null
    jobNoticeAlert = new bootstrap.Modal(document.getElementById('jobNoticeAlert'))
    iframe = document.querySelector('iframe')

    $('#edit_job').on 'ajax:error', ->
      $('#message_block').html(
        '<div class="alert alert-danger fade alert-dismissible show"><ul class="ul-disc ps-3 mb-0"><li>Internal server error</li></ul></div>'
      )

    $("#edit_job").on 'ajax:complete', (event)->
      xhr = event.detail[0]
      if ((xhr.getResponseHeader('Content-Type') || '').substring(0, 9) == 'text/html')
        referrer = xhr.responseURL
        snapshot = Turbolinks.Snapshot.wrap(xhr.response)
        Turbolinks.controller.cache.put(referrer, snapshot)
        Turbolinks.visit(referrer, { action: 'restore' })
        window.dispatchEvent(new Event('load'))
        document.dispatchEvent(new Event('DOMContentLoaded'))
        Turbolinks.dispatch('turbolinks:load')

    $(".other-text-field-tag").each ->
      otherTextElement = $(this)
      otherTextElement.closest('.df-element-main-content-wrapper').find('input[type=radio],input[type=checkbox],select').each ->
        $(this).change ->
          if (if $(this).prop('type') == 'checkbox' then $(this).parent().parent().find('input[value=_other_]').is(':checked') else $(this).val() == '_other_')
            otherTextElement.show()
            otherTextElement.focus()
          else
            otherTextElement.hide()
            otherTextElement.val('')

    setNoticeModalContent = (title, body, leaveCallback) ->
      $('#jobNoticeAlertTitle').text(title)
      $('#jobNoticeAlertBody').text(body)
      footerHtml = """
        <button type="button" class="btn btn-outline-primary m-0 me-1" data-bs-dismiss="modal" aria-label="Close">
          #{window.I18nCancelButton}
        </button>
        <a href="#{leaveUrl}" class="btn btn-primary" id="confirmLeaveBtn">
          #{window.I18nConfirmButton}
        </a>
      """
      $('#jobNoticeAlertFooter').html(footerHtml)
      $('#confirmLeaveBtn').on 'click', ->
        if leaveUrl
          window.location.href = leaveUrl
          jobNoticeAlert.hide()

    $('#edit_job a:not([target="_blank"])').on 'click', (e) ->
      link = $(this).attr('href')
      if link
        try
          clickedUrl = new URL(link, window.location.origin)
          currentDomain = window.location.hostname
          if clickedUrl.hostname != currentDomain
            e.preventDefault()
            leaveUrl = link
            setNoticeModalContent(window.NoticeAlertTitleText, window.NoticeAlertBodyText)
            jobNoticeAlert.show()
        catch error
          console.error 'Invalid URL:', link

    fetchBackgroundImage = ->
      page_background = document.getElementById('page_background')
      jobPromoDiv = document.getElementById('job-background-div')
      default_img_url = jobPromoDiv.getAttribute('data-default-url')


      if page_background
        image_url = page_background.getAttribute('data-background-id')
        if image_url
          if jobPromoDiv
            jobPromoDiv.style.backgroundPosition = 'top center'
            jobPromoDiv.style.backgroundImage = "linear-gradient(0deg, rgba(var(--dashboard-main-background-rgb), 1) 0%, rgba(var(--dashboard-main-background-rgb), 1) 15%, rgba(var(--dashboard-main-background-rgb), 0) 40%), url('"+image_url+"')"
            jobPromoDiv.style.height = '95vh'
            jobPromoDiv.style.position = 'fixed'
            jobPromoDiv.classList.add 'has-page-background'
        else
          jobPromoDiv.classList.remove 'has-page-background'
          if default_img_url
            jobPromoDiv.style.backgroundImage = "linear-gradient(0deg, rgba(var(--dashboard-main-background-rgb), 1) 0%, rgba(var(--dashboard-main-background-rgb), 1) 15%, rgba(var(--dashboard-main-background-rgb), 0) 40%), url('"+default_img_url+"')"
          else
            jobPromoDiv.style.backgroundImage = ''

    fetchBackgroundImage()
    if (iframe)
      cleanupIframeChecker = iframeAdBlockerChecker(iframe)


  if $('#workplace_jobs_edit').length > 0
    { readEml } = require('eml-parse-js')
    { html: beautifyHtml } = require('js-beautify')

    isValidS3Url = (url) ->
      try
        uri = new URL(url)
        uri.protocol == 'https:' and uri.hostname == 's3.eu-west-1.amazonaws.com'
      catch error
        false

    document.querySelectorAll('[id^="filePreviewModal-"]').forEach (modalEl) ->
      modalId = modalEl.id
      fileUrl = modalEl.getAttribute('data-file-url')
      contentEl = document.querySelector("##{modalId}-content")

      return unless fileUrl and contentEl and isValidS3Url(fileUrl)

      contentEl.innerHTML = "<center>Loading...</center>"

      fetch(fileUrl)
        .then (res) -> res.text()
        .then (rawEml) ->
          readEml rawEml, (err, parsed) ->
            if err
              contentEl.textContent = 'Failed to parse .eml file'
              return

            headers = parsed?.headers or {}
            bodyText = parsed?.text or 'n/a'
            bodyHtml = parsed?.html or 'n/a'
            contentType = parsed?.textheaders?['Content-Type'] or 'n/a'

            elementId = modalId.replace('filePreviewModal-', '')
            tabsHtml = """
                <div class="navigation pt-3 position-sticky top-0 bg-w">
                  <ul class="nav nav-tabs mb-3" id="emlTabs-#{elementId}" role="tablist">
                    <li class="nav-item" role="presentation">
                      <a class="nav-link active" id="email-tab" data-bs-toggle="tab" href="#email-#{elementId}" role="tab" aria-controls="email-#{elementId}" aria-selected="true">E-mail</a>
                    </li>
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="metadata-tab" data-bs-toggle="tab" href="#metadata-#{elementId}" role="tab" aria-controls="metadata-#{elementId}" aria-selected="false">Metadata & HTML</a>
                    </li>
                    <li class="nav-item" role="presentation">
                      <a class="nav-link" id="raw-tab" data-bs-toggle="tab" href="#raw-#{elementId}" role="tab" aria-controls="raw-#{elementId}" aria-selected="false">RAW file</a>
                    </li>
                  </ul>
                </div>
                <div class="tab-content" id="emlTabsContent-#{elementId}">
                  <div class="tab-pane fade show active" id="email-#{elementId}" role="tabpanel" aria-labelledby="raw-tab">
                    <div id='email-body'></div>
                  </div>
                  <div class="tab-pane fade" id="metadata-#{elementId}" role="tabpanel" aria-labelledby="metadata-tab">
                    <table class="table table-bordered table-striped mb-0">
                      <tbody>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">From</th><td class="p-2 has-border">#{parsed?.from?.name ? ''} <span class="text-muted">&lt;</span>#{parsed?.from?.email ? 'n/a'}<span class="text-muted">&gt;</span></td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">To</th><td class="p-2 has-border">#{parsed?.to?.name ? ''} <span class="text-muted">&lt;</span>#{parsed?.to?.email ? 'n/a'}<span class="text-muted">&gt;</span></td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">cc</th><td class="p-2 has-border">#{parsed?.cc or '-'}</td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">Date</th><td class="p-2 has-border">#{parsed?.date}</td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">Subject</th><td class="p-2 has-border">#{parsed?.subject}</td></tr>
                        <tr><th scope="row" width="150" class="text-end align-middle txt4 p-1">Content Type</th><td class="p-2 has-border">#{contentType}</td></tr>
                        <tr><th scope="row" width="150" class="text-end txt4 p-2 has-border">Plain Text Body</th><td class="p-2 has-border">#{bodyText?.replace(/\n/g, "<br/>")}</td></tr>
                        <tr><th scope="row" width="150" class="text-end txt4 px-1 py-2">HTML Body</th><td class="p-0" id="html-#{elementId}"></td></tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="tab-pane fade" id="raw-#{elementId}" role="tabpanel" aria-labelledby="raw-tab">
                    <pre class='mb-0'><code class="language-html">#{rawEml.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</code></pre>
                  </div>
                </div>
              """

            contentEl.innerHTML = tabsHtml

            emailBodyContainer = document.querySelector("#email-#{elementId} #email-body")
            if emailBodyContainer?
              if bodyHtml != 'n/a'
                bodyHtml = bodyHtml.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, (match, cssContent) ->
                  "<style>#email-body { #{cssContent} }</style>"
                )
                emailBodyContainer.innerHTML = bodyHtml
              else if bodyText != 'n/a'
                emailBodyContainer.innerHTML = "#{bodyText.replace(/\n/g, "<br/>")}"
              else
                emailBodyContainer.innerHTML = "<div class='p-2 text-muted'>n/a</div>"

            htmlCell = document.getElementById("html-#{elementId}")
            if htmlCell?
              highlighted = document.createElement('pre')
              highlighted.className = 'mb-0'
              code = document.createElement('code')
              code.className = 'language-html'
              code.textContent = beautifyHtml(bodyHtml)
              highlighted.appendChild(code)
              htmlCell.appendChild(highlighted)

            rawCodeEl = document.querySelector("#raw-#{elementId} code")
            if rawCodeEl?
              hljs.highlightElement(rawCodeEl)

            if window.hljs?
              hljs.highlightElement(code)

        .catch (err) ->
          console.error(err)
          contentEl.textContent = 'Error loading file'

      $(document).on 'click', '.pin-modal', (e) ->
        $(this).toggleClass('btn-outline-primary');
        $(this).toggleClass('btn-primary');
        $(this).find('.fa-solid').toggleClass('fa-thumbtack-slash');
        $(this).find('.fa-solid').toggleClass('fa-thumbtack');
        modal = $(this).closest('.modal')
        backdrop = $('.modal-backdrop')

        if modal.hasClass('pinned')
          modal.removeClass('pinned')
          $('body').removeClass('modal-open')
          #modal.modal('hide')
          $('body').removeClass('pinned-modal-open')
        else
          modal.addClass('pinned').addClass('show').css('display', 'block')
          backdrop.remove()
          $('body').removeClass('modal-open')
          $('body').addClass('pinned-modal-open')

      $(document).on 'click', '.modal.pinned .btn-close', (e) ->
        modal = $(this)
        modal.removeClass('pinned')
        modal.css('display', '')
        modal.find('.fa-solid').removeClass('fa-thumbtack-slash').addClass('fa-thumbtack')
        modal.find('.pin-modal').addClass('btn-outline-primary').removeClass('btn-primary')
        $('body').removeClass('pinned-modal-open')

    if $('body').hasClass('rework-job-enabled')
      commentSection = document.getElementById "rework-job-comments"
      reviewCommentData = commentSection.dataset.reviewData
      commentText = if commentSection then commentSection.textContent.trim().toLowerCase() else null
      formLabels = document.querySelectorAll ".col-form-label"
      hiddenCards = 0

      if commentSection and formLabels
        reviewCommentData = JSON.parse(commentSection.dataset.reviewData || "{}")

        if Object.keys(reviewCommentData).length > 0 || commentText?.includes labelText

          if Object.keys(reviewCommentData).length
            for label in formLabels
              fullFor = label.getAttribute("for")?.trim()
              continue unless fullFor

              # Extract the slug from the for attribute (e.g. 'unnamed_image')
              slugMatch = fullFor.match(/df_create_(.+)$/)
              continue unless slugMatch and slugMatch[1]

              slug = slugMatch[1]
              continue unless reviewCommentData[slug]

              label.classList.add "rework-required"
              card = label.closest(".card")
              card?.classList.add "rework-required"



              # Add alert-danger block with comment content
              messages = reviewCommentData[slug]

              label.classList.add "rework-required"
              card = label.closest(".card")
              card?.classList.add "rework-required"

              htmlEscape = (str) ->
                String(str)
                  .replace(/&/g, '&amp;')
                  .replace(/</g, '&lt;')
                  .replace(/>/g, '&gt;')
                  .replace(/"/g, '&quot;')
                  .replace(/'/g, '&#39;')

              buildCard = (innerHtml) ->
                $("<div>")
                  .addClass("card bg-danger-subtle rework-job-comments-card use-default-bs border-2 p-3 mt-2")
                  .html(innerHtml)

              toListHtml = (val) ->
                arr = if Array.isArray(val) then val else String(val or "").split("\n").map((s) -> s.trim()).filter((s) -> s.length > 0)
                return "" if arr.length == 0
                "<ul class='mb-0 ps-3'>" + arr.map((c) -> "<li>#{htmlEscape(c)}</li>").join("") + "</ul>"


              if messages?.general?
                generalHtml = toListHtml(messages.general)
                if generalHtml?.length
                  $(label.parentNode).append(buildCard(generalHtml))

              if messages?.sub? and typeof messages.sub is "object"
                $card = $(card or document)
                for identifier, subVal of messages.sub
                  $ph = $card.find("[data-placeholder-for-media-id='#{identifier}']")
                  if $ph.length == 0
                    $ph = $card.find("[data-placeholder-for-media-name='#{identifier}']")

                  returnHtml = toListHtml(subVal)

                  if $ph.length and returnHtml?.length
                    $ph.empty().append(buildCard(returnHtml))
                    $ph.addClass("rework-required")
                  else if returnHtml?.length
                    safeId = htmlEscape(identifier)
                    fallback = buildCard("<p class='mb-1 fw-bold'>Item: #{safeId}</p>" + returnHtml)
                    $(label.parentNode).append(fallback)




          else if commentText && commentText?.includes labelText
            for label in formLabels
              labelText = label.textContent.trim().toLowerCase()
              if commentText?.includes labelText
                label.classList.add "rework-required"
                card = label.closest ".card"
                card?.classList.add "rework-required"

          # Hide unrelated cards
          $(".card.my-4").each (i, card) ->
            cardEl = $(card)
            unless cardEl.hasClass("rework-required")
              cardEl.addClass("d-none")
              hiddenCards += 1

          if $(".toggle-rework-element").length
            showAll = false
            $(".toggle-rework-element").on "click", ->
              showAll = !showAll
              if showAll
                $(".card.my-4").removeClass("d-none")
                $(".toggle-rework-element").find(".form-check-input").removeClass("checked").removeAttr("checked")
                $(".rework-job-enabled").addClass("with-element-highlighter")
                hiddenCards = null
              else
                $(".card.my-4").each (i, card) ->
                  cardEl = $(card)
                  unless cardEl.hasClass("rework-required")
                    cardEl.addClass("d-none")
                    hiddenCards = +1
                $(".rework-job-enabled").removeClass("with-element-highlighter")
                $(".toggle-rework-element").find(".form-check-input").addClass("checked").attr("checked", "checked")
        else if $(".toggle-rework-element-wrapper").length
          $("#toggle-rework-element-wrapper").addClass("d-none")
  preventPasteInTypingFields = ->
    sel = """
        .o-typing-field input,
        .o-typing-field textarea,
        .o-typing-field .not-editor,
        .o-typing-field .html_editor,
        .o-typing-field [contenteditable="true"]
    """

    showInvalid = ($el) ->
      $wrp = $el.closest('.o-typing-field')
      $ifb = $wrp.find('.invalid-feedback').first()
      $el.addClass('is-invalid')
      $ifb.text($ifb.data('invalid-message') or "Pasting isn't allowed").addClass('d-block') if $ifb.length

    clearInvalid = ($el) ->
      $wrp = $el.closest('.o-typing-field')
      $ifb = $wrp.find('.invalid-feedback').first()
      $el.removeClass('is-invalid')
      $ifb.removeClass('d-block').text('') if $ifb.length

    $(document)
      .off 'paste.oTypingField input.oTypingField'
      .on 'paste.oTypingField', sel, (e) ->
        e.preventDefault()
        showInvalid($(this))

      .on 'input.oTypingField', '.o-typing-field input.is-invalid, .o-typing-field textarea.is-invalid', ->
        clearInvalid($(this))

  preventPasteInTypingFields()



$(document).on 'turbolinks:before-cache', ->
    if typeof cleanupIframeChecker is 'function'
      cleanupIframeChecker()
      cleanupIframeChecker = null

